<template>
  <div>
    <ClubInfoBanner
      v-if="userInClub"
      show-info-icon
      title="Клубная цена"
      subtitle="На все услуги клиники"
    />
    <ClubDiscountSwitch
      v-else
      use-global-dispatch
      title="Клубная цена"
      :enabled="isSwitchEnabled"
      :discount="discountOnServices"
    />
  </div>
</template>

<script>
import ClubInfoBanner from 'www/vue_components/common/Club/components/core/ClubInfoBanner/ClubInfoBanner.vue'
import ClubDiscountSwitch from 'www/vue_components/common/Club/components/core/ClubDiscount/components/common/ClubDiscountSwitch.vue'

export default {
  name: 'ClubServiceDiscountControl',
  components: {
    ClubInfoBanner,
    ClubDiscountSwitch,
  },
  props: {
    isSwitchEnabled: {
      type: Boolean,
      default: false,
    },
    userClubData: {
      type: Object,
      default: () => ({ ...window.USER.club }),
    },
  },
  data: vm => ({
    userInClub: vm.userClubData.isInClub,
    discountOnServices: vm.userClubData.discountOnServices,
  }),
  created() {
    window.addEventListener('club-service-discount:updated-user-data', ({ detail }) => {
      this.userInClub = detail.userClubData.isInClub
    })
  },
}
</script>
